import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';

const IndicatorsSection = ({ indicateurs }) => {
  return (
    <>
      <tr>
        <td className="label" style={{ backgroundColor: '#f9fafb', fontWeight: '600', color: '#4b5563' }}>
          <FontAwesomeIcon icon={faChartLine} /> INDICATEURS
        </td>
        <td className="value" style={{ backgroundColor: '#f9fafb' }}></td>
      </tr>
      <tr>
        <td className="label">
          <span className="accounting-badge standard" style={{ fontSize: '8px' }}>Standard</span> Indicateur
        </td>
        <td className="value">
          <div className="indicator-badge" style={{ backgroundColor: '#e0e7ff', color: '#4f46e5' }}>
            {indicateurs?.standard || '-'}
          </div>
        </td>
      </tr>
      <tr>
        <td className="label">
          <span className="accounting-badge v2" style={{ fontSize: '8px' }}>V2</span> Indicateur
        </td>
        <td className="value">
          <div className="indicator-badge" style={{ backgroundColor: '#e0f2fe', color: '#0284c7' }}>
            {indicateurs?.v2 || '-'}
          </div>
        </td>
      </tr>
    </>
  );
};

export default IndicatorsSection;
